import { EmmaFactory } from '@axa-asia/hk-emma-js';
import React, { Component } from 'react';
import { isApp } from '../../utils';

interface EmmaNavTitleProps {
  title: string;
  component: any;
}

interface EmmaNavTitleState {}

class EmmaNavTitle extends Component<EmmaNavTitleProps, EmmaNavTitleState> {
  componentDidMount() {
    if (isApp()) {
      const title = this.props.title;
      title &&
        EmmaFactory.createInstance().then((p) =>
          p.instance.setNavigationTitle(title),
        );
    }
  }

  render() {
    const { component } = this.props;
    return <div>{!isApp() && component}</div>;
  }
}

export default EmmaNavTitle;
